import React, { useState } from 'react';
import { AutoComplete } from 'antd';
import { CloseCircleFilled, CaretDownFilled } from '@ant-design/icons';
import '../main.css';
import { CustomLoadingIcon, CustomLocaltionIcon } from '../../../assets/icons';
export function AutoCompleteSearch({ options, onSearch, placeholder, onFocus, isLoading, hasError, errorMessage, onSelect, dropdownOpen, setDropdownOpen, }) {
    const [inputValue, setInputValue] = useState('');
    const handleClear = () => {
        setInputValue('');
        onSearch('');
    };
    const handleSelect = (value) => {
        const selected = options.find((option) => option.value === value);
        if (selected) {
            setInputValue(selected.label);
            onSelect(selected);
            setDropdownOpen(false);
        }
    };
    const enhancedOptions = options.map((option) => ({
        value: option.value,
        label: (React.createElement("div", { className: "flex items-center" },
            React.createElement(CustomLocaltionIcon, { className: "text-orange-600" }),
            React.createElement("span", { className: "ml-2" }, option.label))),
    }));
    return (React.createElement("div", { className: "relative flex flex-col" },
        React.createElement(AutoComplete, { "data-testid": "autocomplete-search", className: `ant-select-selector ${hasError ? 'border-red-500' : ''}`, placeholder: placeholder, options: enhancedOptions, onSearch: (value) => {
                setInputValue(value);
                onSearch(value);
            }, value: inputValue, onFocus: () => {
                setDropdownOpen(true);
                onFocus();
            }, onSelect: handleSelect, filterOption: false, status: hasError ? 'error' : undefined, dropdownStyle: { width: 400 }, open: dropdownOpen, notFoundContent: isLoading ? (React.createElement("div", { className: "flex justify-center items-center h-10" },
                React.createElement(CustomLoadingIcon, { className: "animate-spin w-5 h-5" }))) : inputValue.length >= 3 && !isLoading && !options.length && (React.createElement("div", { className: "text-gray-500" }, "Nenhuma cidade encontrada")), suffixIcon: inputValue ? (React.createElement(CloseCircleFilled, { onClick: handleClear, style: { cursor: 'pointer', color: 'rgba(0, 0, 0, 0.45)' }, "data-testid": "clear-icon" })) : (React.createElement(CaretDownFilled, { className: "text-black" })) }),
        hasError && errorMessage && (React.createElement("span", { className: "text-red-500 text-[12px] mt-1 absolute -bottom-6 ml-1" }, errorMessage))));
}
//# sourceMappingURL=index.js.map